import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GLOBAL_WORKFLOW_ID, VariableEditorPermissionLevel } from '@selfai-platform/pipeline-common';
import { provideDialogService } from '@selfai-platform/shell';
import { Observable } from 'rxjs';
import { VariableTableField } from '../../models';
import { GlobalVariablesPermissionService } from '../../services/';
import { PipelineVariablesTreeComponent } from '../pipeline-variables-tree';

@Component({
  selector: 'selfai-platform-global-variables-container',
  standalone: true,
  templateUrl: './global-variables-container.component.html',
  styleUrls: ['./global-variables-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, PipelineVariablesTreeComponent],
  providers: [provideDialogService(), GlobalVariablesPermissionService],
})
export class GlobalVariablesContainerComponent {
  protected readonly excludeColumns = [VariableTableField.USED];
  protected readonly globalWorkflowId = GLOBAL_WORKFLOW_ID;
  protected userPermissions$: Observable<VariableEditorPermissionLevel[]>;

  constructor(private readonly variablesPermissionService: GlobalVariablesPermissionService) {
    this.userPermissions$ = this.variablesPermissionService.getUserPermissions();
  }
}
